import {createContext, useContext, useId, useState} from 'react';

const VisibilityContext = createContext(null);

// Keep the dock preference while switching calls, loading details, or changing view modes.
export function LocationPanelProvider({children}) {
    const state = useState(false);
    return <VisibilityContext.Provider value={state}>{children}</VisibilityContext.Provider>;
}

export default function LocationPanels({children}) {
    const localState = useState(false);
    const [collapsed, setCollapsed] = useContext(VisibilityContext) || localState;
    const panelId = useId();
    return <div className="location-dock">
        <div className="location-dock-header">
            <button type="button" className="panel-collapse-button inline-flex items-center gap-1" aria-expanded={!collapsed}
                aria-controls={panelId} onClick={() => setCollapsed(value => !value)}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d={collapsed ? 'm6 15 6-6 6 6' : 'm6 9 6 6 6-6'}/>
                </svg>
                {collapsed ? 'Show' : 'Hide'}
            </button>
        </div>
        <div id={panelId} className="location-panels" hidden={collapsed}>{children}</div>
    </div>;
}
